module.exports = __webpack_public_path__ + "static/img/Jade_Gresham_mobile.f111ca1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jade_Gresham_mobile.jpg
// module id = wYqO
// module chunks = 0